<template>
  <div class="container-fluid">
    <div class="title-container">
      <h3 class="title">
        Units
        <div
          class="spinner-border spinner-theme_default"
          role="status"
          v-if="isLoading"
        >
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </h3>
    </div>

    <FullscreenTabs>
      <template v-slot:tabsControls>
        <div class="d-flex">
          <div class="table-tab-item" v-for="tab in tabs" :key="tab.name">
            <b-button
              class="button text-capitalize"
              :variant="
                tab.name === currentTab.name ? 'info' : 'secondary-outline'
              "
              @click="setCurrentTab(tab)"
            >
              {{ tab.alias }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:tabsContent>
        <div>
          <TableForPage
            v-show="currentTab.name === 'unitManagers'"
            style="margin-bottom: 0;"
            :tableData="tableData.unitManagers.items"
            :fields="tableData.unitManagers.fields"
            :slots="tableData.unitManagers.slots"
          >
            <template v-slot:teamMembers="props">
              {{ props.item.teamMembers.length }}
            </template>
            <template v-slot:row="slotProps">
              <NestedTable
                :items="slotProps.row.item.teamMembers"
                :fields="tableData.unitManagers.nestedTable.fields"
                :slots="tableData.unitManagers.nestedTable.slots"
              >
                <template v-slot:projects="slotProps">
                  <div
                    v-if="slotProps.item.projects.length"
                    class="units-projects-list"
                  >
                    <div
                      v-for="(project, index) in slotProps.item.projects"
                      :key="index"
                      class="units-projects-item"
                    >
                      <a
                        :href="
                          `https://giraffesoftware.atlassian.net/browse/${
                            project.projectKey
                          }`
                        "
                        class="units-projects-link"
                      >
                        {{ project.projectName }}
                        <span class="fontColor2">{{
                          project.projectSpent
                        }}</span>
                      </a>
                    </div>
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
          <TableForPage
            v-show="currentTab.name === 'projectManagers'"
            style="margin-bottom: 0;"
            :tableData="tableData.projectManagers.items"
            :fields="tableData.projectManagers.fields"
            :slots="tableData.projectManagers.slots"
          >
            <template v-slot:projects="props">
              {{ props.item.projects.length }} projects
            </template>
            <template v-slot:row="slotProps">
              <NestedTable
                :items="slotProps.row.item.projects"
                :fields="tableData.projectManagers.nestedTable.fields"
                :slots="tableData.projectManagers.nestedTable.slots"
              >
                <template v-slot:projectName="slotProps">
                  <div class="units-projects-item">
                    <a
                      :href="
                        `https://giraffesoftware.atlassian.net/browse/${
                          slotProps.item.projectKey
                        }`
                      "
                      class="units-projects-link"
                    >
                      {{ slotProps.item.projectName }}
                    </a>
                  </div>
                </template>
                <template v-slot:teamMembers="slotProps">
                  <div
                    v-if="slotProps.item.teamMembers.length"
                    class="units-projects-list"
                  >
                    <div
                      v-for="(teamMember, index) in slotProps.item.teamMembers"
                      :key="index"
                      class="units-projects-item"
                    >
                      <div class="units-projects-text">
                        {{ teamMember.teamMember }}
                        <span class="fontColor2">{{
                          teamMember.projectSpent
                        }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
          <TableForPage
            v-show="currentTab.name === 'teamMembers'"
            style="margin-bottom: 0;"
            :tableData="tableData.teamMembers.items"
            :fields="tableData.teamMembers.fields"
            :slots="tableData.teamMembers.slots"
          >
            <template v-slot:projects="props">
              {{ props.item.projects.length }} projects
            </template>
            <template v-slot:row="slotProps">
              <NestedTable
                :items="slotProps.row.item.projects"
                :fields="tableData.teamMembers.nestedTable.fields"
                :slots="tableData.teamMembers.nestedTable.slots"
              >
                <template v-slot:projectName="slotProps">
                  <div class="units-projects-item">
                    <a
                      :href="
                        `https://giraffesoftware.atlassian.net/browse/${
                          slotProps.item.projectKey
                        }`
                      "
                      class="units-projects-link"
                    >
                      {{ slotProps.item.projectName }}
                      <span class="fontColor2">{{
                        slotProps.item.projectSpent
                      }}</span>
                    </a>
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
          <TableForPage
            v-show="currentTab.name === 'accountManagers'"
            style="margin-bottom: 0;"
            :tableData="tableData.accountManagers.items"
            :fields="tableData.accountManagers.fields"
            :slots="tableData.accountManagers.slots"
          >
            <template v-slot:projects="props">
              {{ props.item.projects.length }} projects
            </template>
            <template v-slot:row="slotProps">

              <NestedTable
                :items="slotProps.row.item.projects"
                :fields="tableData.accountManagers.nestedTable.fields"
                :slots="tableData.accountManagers.nestedTable.slots"
              >
                <template v-slot:projectName="slotProps">
                  <div class="units-projects-item">
                    <a
                      :href="
                        `https://giraffesoftware.atlassian.net/browse/${
                          slotProps.item.projectKey
                        }`
                      "
                      class="units-projects-link"
                    >
                      {{ slotProps.item.projectName }}
                      <span class="fontColor2">{{
                        slotProps.item.projectSpent
                      }}</span>
                    </a>
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
          <TableForPage
            v-show="currentTab.name === 'businessManagers'"
            style="margin-bottom: 0;"
            :tableData="tableData.businessManagers.items"
            :fields="tableData.businessManagers.fields"
            :slots="tableData.businessManagers.slots"
          >
            <template v-slot:projects="props">
              {{ props.item.projects.length }} projects
            </template>
            <template v-slot:row="slotProps">

              <NestedTable
                :items="slotProps.row.item.projects"
                :fields="tableData.businessManagers.nestedTable.fields"
                :slots="tableData.businessManagers.nestedTable.slots"
              >
                <template v-slot:projectName="slotProps">
                  <div class="units-projects-item">
                    <a
                      :href="
                        `https://giraffesoftware.atlassian.net/browse/${
                          slotProps.item.projectKey
                        }`
                      "
                      class="units-projects-link"
                    >
                      {{ slotProps.item.projectName }}
                      <span class="fontColor2">{{
                        slotProps.item.projectSpent
                      }}</span>
                    </a>
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
        </div>
      </template>
    </FullscreenTabs>
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'
import NestedTable from '@tables/NestedTable'
import FullscreenTabs from '@components/Fullscreen/FullscreenTabs'

export default {
  name: 'units',
  components: {
    TableForPage,
    NestedTable,
    FullscreenTabs
  },
  data () {
    return {
      isLoading: false,
      currentTab: { name: 'unitManagers', alias: 'Unit managers' },
      tabs: [
        { name: 'unitManagers', alias: 'Unit managers' },
        { name: 'projectManagers', alias: 'Project managers' },
        { name: 'teamMembers', alias: 'Team members' },
        { name: 'accountManagers', alias: 'Account Managers' },
        { name: 'businessManagers', alias: 'Business Managers' }
      ],
      tableData: {
        unitManagers: {
          items: [],
          fields: [
            {
              key: 'unitManager',
              label: 'Name',
              class: 'column-unit-name',
              sortable: false
            },
            {
              key: 'teamMembers',
              label: 'Team members',
              sortable: false
            },
            {
              key: 'more',
              label: 'More',
              class: 'column-more'
            }
          ],
          slots: {
            teamMembers: {
              name: 'teamMembers'
            }
          },
          nestedTable: {
            fields: [
              {
                key: 'teamMember',
                label: 'Team member',
                class: 'column-units-nested-name',
                sortable: false
              },
              {
                key: 'projects',
                label: 'Projects',
                sortable: false
              }
            ],
            slots: {
              projects: {
                name: 'projects'
              }
            }
          }
        },
        projectManagers: {
          items: [],
          fields: [
            {
              key: 'projectManager',
              label: 'Name',
              class: 'column-unit-name',
              sortable: false
            },
            {
              key: 'projects',
              label: 'Projects sum',
              sortable: false
            },
            {
              key: 'more',
              label: 'More',
              class: 'column-more'
            }
          ],
          slots: {
            projects: {
              name: 'projects'
            }
          },
          nestedTable: {
            fields: [
              {
                key: 'projectName',
                label: 'Projects',
                class: 'column-units-nested-name',
                sortable: false
              },
              {
                key: 'teamMembers',
                label: 'Team member',
                sortable: false
              }
            ],
            slots: {
              projectName: {
                name: 'projectName'
              },
              teamMembers: {
                name: 'teamMembers'
              }
            }
          }
        },
        teamMembers: {
          items: [],
          fields: [
            {
              key: 'teamMember',
              label: 'Name',
              class: 'column-unit-name',
              sortable: false
            },
            {
              key: 'projects',
              label: 'Projects sum',
              sortable: false
            },
            {
              key: 'more',
              label: 'More',
              class: 'column-more'
            }
          ],
          slots: {
            projects: {
              name: 'projects'
            }
          },
          nestedTable: {
            fields: [
              {
                key: 'projectName',
                label: 'Projects',
                class: 'column-units-nested-name',
                sortable: false
              },
              {
                key: 'projectManager',
                label: 'Project manager',
                sortable: false
              },
              {
                key: 'projectManager',
                label: 'Project manager',
                sortable: false
              },
              {
                key: 'projectManager',
                label: 'Project manager',
                sortable: false
              }
            ],
            slots: {
              projectName: {
                name: 'projectName'
              }
            }
          }
        },
        accountManagers: {
          items: [],
          fields: [],
          slots: {},
          nestedTable: {
            fields: [],
            slots: {}
          }
        },
        businessManagers: {
          items: [],
          fields: [],
          slots: {},
          nestedTable: {
            fields: [],
            slots: {}
          }
        }
      }
    }
  },
  mounted () {
    this.isLoading = true
    this.axios({
      method: 'get',
      url: '/api/unit/unit-manager',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        this.isLoading = false
        this.tableData.unitManagers.items = Object.values(response.data)
      })
      .catch(err => {
        this.isLoading = false
        console.log(err)
      })
    this.axios({
      method: 'get',
      url: '/api/unit/project-manager',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        this.isLoading = false
        this.tableData.projectManagers.items = Object.values(response.data)
      })
      .catch(err => {
        this.isLoading = false
        console.log(err)
      })
    this.axios({
      method: 'get',
      url: '/api/unit/team-members',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        this.isLoading = false
        this.tableData.teamMembers.items = Object.values(response.data)
      })
      .catch(err => {
        this.isLoading = false
        console.log(err)
      })
  },
  methods: {
    setCurrentTab (tab) {
      this.currentTab = tab
    }
  }
}
</script>

<style lang="scss">
.max-width-block {
  max-width: 200px;
}
.height-load {
  height: 34.5px;
}
.font-size-project {
  font-size: 14px;
}
.units-projects-list {
  display: flex;
  flex-wrap: wrap;
}
.units-projects-item {
  margin-right: 10px;
}
.units-projects-link {
  font-size: 12px;
  color: $fontColorAccent;
}
.units-projects-text {
  font-size: 12px;
  color: $fontColorBase;
}
.column-units-nested-name {
  width: 150px;
}
.column-unit-name {
  font-weight: bold;
}
</style>
